import React from "react";
import { createCustomerObject } from "../tools/data-creator";
import { maskText } from "../utils/mask";
export default (props) => {
    const customerObject = createCustomerObject(props.data.customer, props.getAddress());
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium font-size-small" }, "F\u00F6rnamn")),
            React.createElement("div", { className: "column" }, maskText(customerObject.givenName))),
        React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium font-size-small" }, "Efternamn")),
            React.createElement("div", { className: "column" }, maskText(customerObject.surname))),
        React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium font-size-small" }, "Gatuadress")),
            React.createElement("div", { className: "column" }, customerObject.street)),
        React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium font-size-small" }, "Postnummer")),
            React.createElement("div", { className: "column" }, customerObject.zip)),
        React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium font-size-small" }, "Postort")),
            React.createElement("div", { className: "column" }, customerObject.city)),
        React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium font-size-small" }, "E-post")),
            React.createElement("div", { className: "column" }, props.data.customer.email)),
        React.createElement("div", { "data-ecom-columnrow": "", className: "repeat-m-half" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium font-size-small" }, "Telefonnummer")),
            React.createElement("div", { className: "column" }, props.data.customer.phone))));
};
